export const newUserInfo = () => {
  return {
    id: null,
    name: null,
    email: null,
    profile_picture: '',
    people: [],
    firstAccess: false,
    email_verified_at: '',
    roles: [],
    token: ''
  }
}

const MARITAL_STATUS = [
  { code: 'S', name: 'Solteiro' },
  { code: 'C', name: 'Casado' },
  { code: 'V', name: 'Viúvo' },
  { code: 'J', name: 'Separado Judicialmente' },
  { code: 'D', name: 'Divorciado' }
]

const GENDERS = [
  { code: 'M', name: 'Masculino' },
  { code: 'F', name: 'Feminino' }
]

const ACCOUNT_TYPES = [
  { code: 'CC', name: 'Conta Corrente' },
  { code: 'CP', name: 'Conta Poupança' }
]

export default {
  MARITAL_STATUS: MARITAL_STATUS,
  GENDERS: GENDERS,
  ACCOUNT_TYPES: ACCOUNT_TYPES,
}